import React, { Component } from 'react'
import { connect } from 'react-redux'

// Utils
import { formatCurrency } from '../../../utils/currency'
import { translation } from '../../../utils/helpers'

// Styles
import './index.scss'

class DummyExtent extends Component {

  constructor (props) {
    super(props)
    this.state = {
      item: props.item,
      showAgreementPrice: window.localStorage.getItem('showAgreementPrice') === '1'
    }
  }

  renderForsiReport () {
    let { DummyForsiReports } = this.state.item
    if (DummyForsiReports === null) return null
    const renderDummyForsi = (item, key) => {
      let hasPaint = item.PaintHours > 0
      let hasBodywork = item.BodyHours > 0

      // 13535 'Timekorrektion @'
      // 13536 'Tillæg @'
      // 13537 'Plade timepris @'
      // 13538 'Plade materialepris @'
      // 13539 'Plade arbejdspris @'
      // 13540 'Plade arbejdstimer @'
      // 13541 'Lak timepris @'
      // 13542 'Lak materialepris @'
      // 13543 'Lak arbejdspris @'
      // 13544 'Lak arbejdstimer @'
      // 13545 'Plade ordre rabat @'
      // 13546 'Manuelt pladeomfang'
      // 13547 'Manuelt lakomfang'
      // 13548 'Lak ordre'
      return (
        <li key={key}>
          <div>
            {hasBodywork && (
              <div className='extent_dummy'>
                <div className='clearfix title'>{translation('781')}</div>
                <div className='clearfix'>
                  <label>{translation('13540')}</label>
                  <span>{formatCurrency(item.BodyHours)}</span>
                </div>
                <div className='clearfix'>
                  <label>{translation('13537')}</label>
                  <span>{formatCurrency(item.BodyHourPrice)}</span>
                </div>
                <div className='clearfix'>
                  <label>{translation('13538')}</label>
                  <span>{formatCurrency(item.BodyMaterialsPrice)}</span>
                </div>
                <div className='clearfix'>
                  <label>{translation('13539')}</label>
                  <span>{formatCurrency(item.BodyWorkPrice)}</span>
                </div>
                {item.BodyCorrectionPrice !== 0 && (
                  <div className='clearfix'>
                    <label>{translation(item.BodyCorrectionText)}</label>
                    <span>{formatCurrency(item.BodyCorrectionPrice)}</span>
                  </div>
                )}
                <div className='clearfix'>
                  <label>{translation('13353')}</label>
                  <span>{formatCurrency(item.BodyTotalAfterCorrection)}</span>
                </div>
                <div>&nbsp;</div>
              </div>
            )}
            {hasPaint && (
              <div className='extent_dummy'>
                <div className='clearfix title'>{translation('13548')}</div>
                <div className='clearfix'>
                  <label>{translation('13544')}</label>
                  <span>{formatCurrency(item.PaintHours)}</span>
                </div>
                <div className='clearfix'>
                  <label>{translation('13541')}</label>
                  <span>{formatCurrency(item.PaintHourPrice)}</span>
                </div>
                <div className='clearfix'>
                  <label>{translation('13542')}</label>
                  <span>{formatCurrency(item.PaintMaterialsPrice)}</span>
                </div>
                <div className='clearfix'>
                  <label>{translation('13543')}</label>
                  <span>{formatCurrency(item.PaintWorkPrice)}</span>
                </div>
                {item.PaintCorrectionPrice !== 0 && (
                  <div className='clearfix'>
                    <label>{translation(item.PaintCorrectionText)}</label>
                    <span>{formatCurrency(item.PaintCorrectionPrice)}</span>
                  </div>
                )}
                <div className='clearfix'>
                  <label>{translation('13353')}</label>
                  <span>{formatCurrency(item.PaintTotalAfterCorrection)}</span>
                </div>
                <div>&nbsp;</div>
              </div>
            )}
            <div className='extent_dummy'>
              <div className='clearfix title'>
                {translation('945')}
                <span>{formatCurrency(item.TotalAfterCorrection)}</span>
              </div>
            </div>
          </div>
        </li>
      )
    }
    // Render
    return (
      <div className='form'>
        <div className='title'>{translation('13438')}</div>
        <div>
          <ul>
            {DummyForsiReports.map(renderDummyForsi)}
          </ul>
        </div>
      </div>
    )
  }
  render () {
    let isDummy = this.state.item.IsDummy
    const renderDummy = (key, value) => {
      return (
        <li className='clearfix' key={value}>
          <div>{key}</div>
        </li>
      )
    }
    if (isDummy) {
      let dummyTextArray = this.state.item.DummyText.split('<br />')
      let extentArray = this.state.item.OrderExtent.split('<br />')
      let hasDummyText = this.state.item.DummyText !== '' && dummyTextArray !== undefined && dummyTextArray !== null && dummyTextArray.length > 0
      let hasExtent = this.state.item.OrderExtent !== '' && extentArray !== undefined && extentArray !== null && extentArray.length > 0
      return (
        <div className='dummy__view'>
          {hasDummyText && (<ul className='extent_dummy'>
            <div className='title'>{translation('13546')}</div>
            {extentArray.map(renderDummy)}
          </ul>)}
          {hasExtent && (<ul className='extent_dummy'>
            <div className='title'>{translation('13547')}</div>
            {dummyTextArray.map(renderDummy)}
          </ul>)}
          {this.renderForsiReport()}
          <div className='extent_dummy'>
            <div className='clearfix'>
              <label>{translation('641')}</label>
              <span>{formatCurrency(this.state.item.TotalPrice || 0)}</span>
            </div>
            <div className='clearfix'>
              <label>{translation('13339')}</label>
              <span>{formatCurrency(this.state.item.Environment || 0)}</span>
            </div>
            <div className='clearfix'>
              <label>{translation('2325')}</label>
              <span>{formatCurrency(this.state.item.AddonPrice || 0)}</span>
            </div>
            <div className='clearfix'>
              <label>{translation('2326')}</label>
              <span>{formatCurrency(this.state.item.AddonEnvironment || 0)}</span>
            </div>
          </div>
        </div>
      )
    }
    return undefined
  }
}

function mapStateToProps (state) {
  return {
    auth: state.auth
  }
}
export default connect(mapStateToProps, {
})(DummyExtent)



// WEBPACK FOOTER //
// ./src/app/shared/components/DummyExtent/index.js